// Keep a self-referential <link rel="canonical"> in sync per navigation.
//
// The router's afterEach hook calls this on every navigation, same as
// applyRobotsMeta. The canonical is always origin + path of the page
// you're actually on — never a hardcoded apex URL.
//
// Why self-referential and not a static tag in index.html: the same
// SPA serves the marketing apex, the per-tenant booking pages, and
// every sub-route from one index.html. A static
// `<link rel="canonical" href="https://stemne.no/">` would tell Google
// that /pricing, /faq, and every tenant booking page all canonicalize
// to the apex homepage — which would de-index them. A self-referential
// canonical can never lie: each URL points at itself.
//
// Query and hash are stripped on purpose. Marketing routes carry no
// meaningful query params, and the private token-bearing routes
// (?token=…) are noindex anyway, so collapsing them to their bare path
// is the correct canonical even on the off chance a crawler reaches one.
//
// Exported separately from router/index.ts so vitest can exercise the
// DOM-mutation logic without the full router. Side-effect-free: no
// top-level mutation.

const REL = 'canonical'

export function applyCanonical(
  path: string,
  origin: string = window.location.origin,
  doc: Document = document,
): void {
  const href = `${origin}${path}`
  let link = doc.head.querySelector<HTMLLinkElement>(`link[rel="${REL}"]`)
  if (!link) {
    link = doc.createElement('link')
    link.setAttribute('rel', REL)
    doc.head.appendChild(link)
  }
  link.setAttribute('href', href)
}
